<p-card header="Services">
  <p-table
    [value]="serviceList"
    [loading]="loadingServices"
    [responsive]="true"
    headerStyle="{'display': 'block !important'}"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>NAME</th>
        <th>ACCESS</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-service>
      <tr>
        <td>
          <div>
            {{ service['service'].name }}
            <tooltip-button
              [tooltip]="service['service'].description"
              *ngIf="service['service'].description"
            ></tooltip-button>
          </div>
        </td>
        <td>
          <p-inputSwitch
            [(ngModel)]="service.allowed"
            (onChange)="handleChange(service)"
          ></p-inputSwitch>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="clearfix"></div>
</p-card>
